// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".piece_body[data-v-958225a0]{float:left;width:5rem;height:5rem;margin-left:.9375rem;overflow:hidden}", ""]);
// Exports
module.exports = exports;
